import { render, staticRenderFns } from "./fieldOpinionScale.vue?vue&type=template&id=9248ff22"
import script from "./fieldOpinionScale.vue?vue&type=script&lang=js"
export * from "./fieldOpinionScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports